var _path, _path2, _path3, _rect, _rect2, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 109,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.1 54.5V40a8 8 0 0 1 2.4-5.8l22-21.1a8 8 0 0 1 13.5 5.7v71.4a8 8 0 0 1-13.6 5.7l-22-21.1A8 8 0 0 1 118 69l.1-14.5Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102 41a6 6 0 0 1 6-6h13v39h-13a6 6 0 0 1-6-6V41ZM16.1 54.5V40a8 8 0 0 1 2.4-5.8l22-21.1A8 8 0 0 1 54 18.8v71.4a8 8 0 0 1-13.6 5.7l-22-21.1A8 8 0 0 1 16 69l.1-14.5Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 41a6 6 0 0 1 6-6h13v39H6a6 6 0 0 1-6-6V41Z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 192.3,
    y: 34.9,
    width: 8,
    height: 48,
    rx: 2,
    transform: "rotate(45 192.3 35)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 197.9,
    y: 68.9,
    width: 8,
    height: 48,
    rx: 2,
    transform: "rotate(135 198 68.9)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m79 82-4 4.4a2 2 0 0 1-3 0l-2.7-3a2 2 0 0 1 .1-2.8l5.4-5.2.3-.4 3.8-6.3.2-.4 1.8-6.3.1-.5.5-6.4V55l-.5-6.4V48l-2-6.3a2 2 0 0 0-.1-.4L75 34.9a2 2 0 0 0-.2-.3L70 29.1a2 2 0 0 1-.2-2.4l2.2-3.3a2 2 0 0 1 3.2-.2L79 28l4.9 6.6.2.4 2.9 6.5 2 6.5v14l-2 6.5-3 6.5-.1.4L79 82Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66 74.4a2 2 0 0 1-3.4-.3l-2.1-4.6a2 2 0 0 1 0-2l4.2-6.3c.2-.3.3-.6.3-1l.5-6v-.3l-.5-6.1a2 2 0 0 0-.3-1l-4-6.3a2 2 0 0 1 0-2l2-3.4a2 2 0 0 1 3.1-.3l4.9 5.4.4.7 1.8 6 .1.6V61L71 67.2l-.3.6-4.8 6.6Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundIcon);
export default __webpack_public_path__ + "static/media/sound-icon.f178cc9a510ddd642ab6ac03591742d7.svg";
export { ForwardRef as ReactComponent };